<dialog-gala (clickClose)="hideModal()">
    <span gala-dialog-titre>{{translate.instant("APPSYNC.DETAILS")}}</span>
    <div>
        <!----------------------------------- INFORMATIONS ------------------------------------->
        <div class="row">
            <!-- colonne 1 -->
            <div class="col-md-5">
                <input-gala type="text" [disabled]="true" [label]="lgTrad.NAME" [value]="synchro?.AGENT?.NOM" />
                <input-gala type="text" [disabled]="true" [label]="lgTrad.SURNAME" [value]="synchro?.AGENT?.PRENOM" />
            </div>
            <!-- colonne 2 -->
            <div class="col-md-2"></div>
            <!-- colonne 3 -->
            <div class="col-md-5">
                <input-gala type="text" [label]="lgTrad.DEBSYNC" [disabled]="true"
                    [value]="synchro?.DEBSYNC | dateTimeFormat" />
                <input-gala type="text" [label]="lgTrad.FINSYNC" [disabled]="true"
                    [value]="synchro?.FINSYNC | dateTimeFormat" />

            </div>
        </div>
        <div class="row">
            <div class="col-md-7">
                <input-gala type="text" [disabled]="true" [label]="lgTrad.ORGANISME"
                    [value]="synchro?.AGENT?.LISTESIG[0]?.NOMSIG" />
            </div>
            <div class="col-md-5 pt-2">
                <cp-icon-sync [statut]="synchro?.SYNCHOK" />
            </div>
        </div>
        <hr />

        <!----------------------------------   CHEPTEL  ----------------------------->
        <div class="row">
            <div class="col-md-5">
                <table class="table table-striped">
                    <thead class="bg-primary">
                        <tr>
                            <th>{{translate.instant("APPSYNC.CLIENTSYNC")}}</th>
                            <th colspan="2"></th>
                        </tr>
                    </thead>
                    @for (elev of synchro?.CLIENTS; track elev; let i = $index) {
                    <tr>
                        <td>
                            @if (elev?.CLIENT?.NUCHEP){
                            <menu-client [client]="elev?.CLIENT">{{elev?.CLIENT?.COPACH + " " +
                                elev?.CLIENT?.NUCHEP}}</menu-client>
                            } @else {
                            <div>Client inconnu : {{elev?.CLIENT?.NUMEUL}} </div>
                            }
                        </td>
                        <td>
                            <cp-icon-sync [statut]="elev?.SYNCHOK" />
                        </td>
                        <td>
                            @if (cheptel?.SHOW && cheptel?.IDELEVSYNC === elev?.IDELEVSYNC) {
                            <gala-btn (click)="showModules(elev)">
                                <i class="fas fa-search-minus"></i>
                            </gala-btn>
                            } @else {
                            <gala-btn (click)="showModules(elev)">
                                <i class="fas fa-search-plus"></i>
                            </gala-btn>
                            }
                        </td>
                    </tr>
                    }
                </table>
            </div>
            @if (cheptel?.SHOW) {
            <div class="col-md-7 animated fadeIn">
                <table class="table table-striped">
                    <thead class="bg-primary">
                        <tr>
                            <th colspan="4">
                                {{translate.instant("APPSYNC.NUMULDETAILS", { libelle: cheptel.CLIENT.NUCHEP ??
                                cheptel.CLIENT.NUMEUL })}}</th>
                        </tr>
                    </thead>
                    @for (modules of cheptel.MODULES; track modules; let i = $index) {
                    <tbody>
                        <tr>
                            <td>{{modules.MODULE.LIB}}</td>
                            <td>{{modules.NBUP}} {{tNBUP.get(modules.MODULE.ID)}}</td>
                            <td>{{modules.NBUP2}} {{tNBUP2.get(modules.MODULE.ID)}}</td>
                            <td>
                                <cp-icon-sync [statut]="modules.SYNCHOK" />
                            </td>
                        </tr>
                        @if (modules.ANOMALIES && modules?.ANOMALIES.length > 0 ) {
                        @for (ano of modules.ANOMALIES; track ano) {
                        <tr>
                            <td colspan="4">{{translate.instant("APPSYNC.ANOMSG", { libelle: ano.MSG })}}</td>
                        </tr>
                        }
                        }
                    </tbody>
                    }
                </table>
            </div>
            }
        </div>
    </div>
    <div gala-dialog-actions>
        <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.RETOUR}}</button>
    </div>
</dialog-gala>